import type { Role } from '@shared/constants/business/user';

/**
 * Maps user roles to their corresponding colors for UI display
 */
export const ROLE_COLORS: Record<Role, string> = {
    // Admin roles - Red/Pink tones (highest authority)
    super_admin: 'red',

    // Read-only admin role
    admin_read_only: 'grey',

    // Granular admin console roles
    admin_org_manager: 'volcano',
    admin_user_manager: 'gold',
    admin_content_manager: 'cyan',
    admin_comms_manager: 'purple',
    admin_ai_manager: 'blue',
    admin_system_ops: 'red',
    admin_ops_reader: 'orange',
    admin_support_manager: 'geekblue',
    admin_support_user: 'blue',

    // Org admin roles - Purple tones (high authority)
    org_admin: 'purple',

    // Manager roles - Blue tones (management level)
    user_manager: 'blue',

    // Special roles - Orange tones (special purpose)
    supplier: 'orange',
    auto_detect_user: 'cyan',
    shared_edit_user: 'geekblue',
    attestations_user: 'magenta',
    website_checker_user: 'lime',
    market_pds_user: 'geekblue',
    training_manager: 'gold',
    fleet_portal_user: 'orange',

    // Regular user - Green tones (standard access)
    user: 'green',
} as const;

/**
 * Type guard to check if a string is a valid Role
 */
function isValidRole(role: string): role is Role {
    return role in ROLE_COLORS;
}

/**
 * Gets the appropriate color for a given role
 * @param role - The role to get color for
 * @returns The color string for the role, defaults to 'default' if role not found
 */
export function getRoleColor(role: Role): string;
export function getRoleColor(role: string): string;
export function getRoleColor(role: string): string {
    if (isValidRole(role)) {
        return ROLE_COLORS[role];
    }
    return 'default';
}
